import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppState } from './app.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
    constructor(private appState: AppState, private router: Router)
 {}
     canActivate(): boolean {
        return this.canAccess();
      }
    
     canLoad(): boolean {
        return this.canAccess();
     }
    
     private canAccess(): boolean {
        const user = this.appState.user.getValue();
        if (user?.userSubId) {
            return true;
        }   
        this.appState.logOut();
        return false;
      }
}